import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  LinearProgress,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import MaskAndValid from "utils/maskAndValid";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { useFormik } from "formik";
import useLogs from "hooks/logs";

const RadioOption = withStyles(() => ({
  label: {
    fontSize: "1rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      root: {
        "&$disabled": {
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          color: "rgba(0, 0, 0, 0.6)",
        },
        height: "2.5rem",
        fontSize: "0.95rem",
        fontWeight: "500",
      },
    },
  },
});

export default function DialogMonitorDeTeares({
  open,
  formType,
  onClose,
  selectedReason,
  onUpdated,
  typeProcessingList,
}) {
  const [submitting, setSubmitting] = useState(false);
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const [typeProcessing, setTypeProcessing] = useState(
    typeProcessingList[0]?.IdTipoTratativa
  );
  const [shiftOptions, setShiftOptions] = useState([]);

  const getShiftOptions = async () => {
    try {
      const response = await Api.get("weave-shift-list", "weave", "", true);

      setShiftOptions(response.Result);
    } catch (error) {
      console.log(error);
      setLocalStorageApiProblem({
        idMenuAccess: "136",
        screen: "Monitor de teares",
        problem: `Erro na chamada do endpoint weave-shift-list - ${error}`,
      });
    }
  };

  const submit = async (values) => {
    const { usuario, turnoResolucao } = values;
    setSubmitting(true);

    await Api.put(
      "edit-fail-register",
      "weave",
      {
        idLancamentoFalha: selectedReason?.IdLancamentoFalha?.toString(),
        idPista: selectedReason?.IdPista?.toString(),
        idMotivoFalha: selectedReason?.Motivo?.IdMotivoFalha?.toString(),
        quantidadeFalha: selectedReason?.QuantidadeFalha?.toString(),
        idTipoTratativa: typeProcessing?.toString(),
        usuarioResolucao: usuario?.toString(),
        idTurnoResolucao: turnoResolucao?.toString(),
        observacao: selectedReason?.Observacao,
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(`Usuário da resolução editado com sucesso!`, {
            severity: "success",
          });
          handleClose(res.Result);
          onUpdated("true");
        } else {
          snackbar.showMessage(
            `Ocorreu um erro ao editar o usuário da resolução. Verifique os parâmetros informados.`,
            {
              severity: "error",
            }
          );
          setSubmitting(false);
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);
        setLocalStorageApiProblem({
          idMenuAccess: "136",
          screen: "Monitor de teares",
          problem: `Erro na chamada do endpoint edit-fail-register - ${error}`,
        });
      });
  };

  const handleClose = (editedReason) => {
    onClose(editedReason);
  };

  const formik = useFormik({
    initialValues: {
      usuario: "",
      turnoResolucao: "",
    },
    onSubmit: submit,
  });

  const { values, handleChange, handleSubmit } = formik;

  useEffect(() => {}, [selectedReason]);
  useEffect(() => {
    getShiftOptions();
  }, []);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {`Informações da Falha`}
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
              <>
                <Grid container>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Turno de Registro</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="turnoRegistro"
                          fullWidth
                          disabled={true}
                          value={selectedReason?.TearTurnoRegistro?.Descricao}
                          variant="outlined"
                          inputProps={{ min: 0 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Data/Hora de registro</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="dataHoraRegistro"
                          fullWidth
                          disabled={true}
                          value={selectedReason?.DataHoraLancamentoFormat}
                          variant="outlined"
                          inputProps={{ min: 0 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup>
                      <FormLabel>Número do Tear</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="numeroTear"
                          fullWidth
                          disabled={true}
                          value={selectedReason?.IdTear}
                          variant="outlined"
                          inputProps={{ min: 0 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup>
                      <FormLabel>Número da Pista</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="numeroPista"
                          fullWidth
                          disabled={true}
                          value={selectedReason?.IdPista}
                          variant="outlined"
                          inputProps={{ min: 0 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Motivo</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="motivo"
                          fullWidth
                          disabled={true}
                          value={selectedReason?.Motivo?.DescMotivoFalha}
                          variant="outlined"
                          inputProps={{ min: 0 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Observação</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="observacao"
                          fullWidth
                          disabled={true}
                          value={selectedReason?.Observacao || ""}
                          variant="outlined"
                          inputProps={{ min: 0 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel required>Tipo de Tratativa</FormLabel>
                    <RadioGroup
                      aria-label="opções de tratativa"
                      required
                      name="tratativa"
                      value={typeProcessing}
                      disabled={submitting}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2,1fr)",
                      }}
                    >
                      {typeProcessingList.map((type) => {
                        return (
                          <RadioOption
                            key={type?.IdTipoTratativa}
                            value={type?.IdTipoTratativa}
                            onClick={() =>
                              setTypeProcessing(type?.IdTipoTratativa)
                            }
                            checked={typeProcessing === type?.IdTipoTratativa}
                            control={<Radio size="small" color="primary" />}
                            label={type.Descricao}
                          />
                        );
                      })}
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup>
                      <FormLabel required>Quantidade de Falhas</FormLabel>
                      <ThemeProvider theme={theme}>
                        <TextField
                          name="quantidadeFalha"
                          type="number"
                          required
                          fullWidth
                          disabled={true}
                          value={selectedReason?.QuantidadeFalha}
                          variant="outlined"
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 10);
                          }}
                          onChange={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 10);
                          }}
                          inputProps={{ min: 1 }}
                        />
                      </ThemeProvider>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup>
                      <FormLabel required>Usuário de Resolução</FormLabel>
                      <Tooltip
                        title="Informe o usuário de Resolução"
                        placement="bottom"
                      >
                        <TextField
                          name="usuario"
                          type="number"
                          required
                          fullWidth
                          disabled={submitting}
                          value={values.usuario}
                          variant="outlined"
                          onChange={handleChange}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 50);
                          }}
                          inputProps={{ min: 0 }}
                        />
                      </Tooltip>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Turno de Resolução</FormLabel>
                      <Tooltip title="Informe o turno de resolução">
                        <FormControl
                          variant="outlined"
                          fullWidth
                          disabled={submitting || shiftOptions.length === 0}
                        >
                          <Select
                            name="turnoResolucao"
                            fullWidth
                            value={values.turnoResolucao}
                            onChange={handleChange}
                            IconComponent={KeyboardArrowDown}
                          >
                            {shiftOptions.map((option) => (
                              <MenuItem
                                key={option.IdTurno}
                                value={option.IdTurno}
                              >
                                {option.Descricao}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Tooltip>
                    </FormGroup>
                  </Grid>
                </Grid>
              </>
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>{`${
                    formType === "create" ? "Cadastrando" : "Editando"
                  } informações da falha...`}</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>
            <Button
              color="default"
              variant="contained"
              type="submit"
              disabled={
                submitting ||
                MaskAndValid.isNullOrEmpty(values.usuario) ||
                MaskAndValid.isNullOrEmpty(values.turnoResolucao)
              }
            >
              {formType === "edit" ? "Atualizar" : "Cadastrar"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
